import { useContext, useEffect, useState } from 'react';
import context from '../../context/context';
import LoadingAnimation from '../loading-animation/loading-animation';
import './news-and-media-media-filters.scss';

const className = 'news-and-media-media-filters';

const NewsAndMediaMediaFilters = ({ data }) => {
	const [mediaFilters, setMediaFilters] = useState([]);
	const [activeFilters, setActiveFilters] = useState([]);
	const [initialLoad, setInitialLoad] = useState(true);
	const {
		setContentGlobal,
		setAdditionalGlobal,
		setTriggerRefresh,
		setFiltersGlobal,
	} = useContext(context);

	// Effect to update global filters state when data changes
	useEffect(() => {
		if (data.success) {
			setMediaFilters(data.data.media_type);
		}
	}, [data]);

	// Effect to update global state and trigger refresh when activeFilters change
	useEffect(() => {
		// Trigger loading animation
		if (initialLoad === false) {
			setAdditionalGlobal((prev) => ({
				...prev,
				page: 1,
			}));
			setFiltersGlobal((prev) => ({
				...prev,
				media_type: activeFilters,
			}));
			setContentGlobal([]);
			setTriggerRefresh(true);
		}
		setInitialLoad(false);
	}, [activeFilters]);

	// Handle filter click to add/remove filters
	const handleFilterClick = (term_id) => {
		setActiveFilters((prevFilters) =>
			prevFilters.includes(term_id)
				? prevFilters.filter((id) => id !== term_id)
				: [...prevFilters, term_id]
		);
	};

	// Show loading animation if filters are not loaded
	if (data.success !== true) {
		return <LoadingAnimation type={className} />;
	}

	// Render the list of filters
	return (
		<ul className={className}>
			{mediaFilters.map((mediaFilter) => (
				<li
					className={`${className}__item ${
						activeFilters.includes(mediaFilter.value)
							? `${className}__item--active`
							: ''
					}`}
					key={mediaFilter.value}
					onClick={() => handleFilterClick(mediaFilter.value)}
				>
					{mediaFilter.label}
				</li>
			))}
		</ul>
	);
};

export default NewsAndMediaMediaFilters;
